export default {
    afterInit: function(component){
        var questions = component.survey.questions;
        for(let q=0; q<questions.length; q++){
            var question = questions[q];

            switch(question.config.id){
                case 6:
                    if(question.config.type=='DatePicker'){
                        question.config.type_modifier.DatePicker.allow_dates = function(val){
                            var today = new Date();
                            var date = new Date(val);
                            return date<=today;
                        }

                        question.actions = function(question, questionMap, language){
                            var date = question.value[1][1] ? new Date(question.value[1][1]) : null;
                            var rawDate = question.value[1][1];
                            if(date){
                                var target = questionMap[29];
                                target.update.subtext({
                                    es: "La fecha del diagnóstico es <span style='color:red;'>"+rawDate+"</span>",
                                    en: "Date of diagnosis was <span style='color:red;'>"+rawDate+"</span>",
                                    pt: "A data do diagnóstico foiÇ <span style='color:red;'>"+rawDate+"</span>"
                                })
                            }                            
                        }
                    }else{
                        console.error('Expected DatePicker',question);
                    }
                break;

                case 29:
                    if(question.config.type=='DatePicker'){
                        question.config.type_modifier.DatePicker.allow_dates = function(val){
                            var today = new Date();
                            var date = new Date(val);

                            var t1 = 6;

                            var target = component.questionMap[t1].value[1][1] ? new Date(component.questionMap[t1].value[1][1]) : null;
                            var beforeToday = date<=today;
                            var afterTarget = date>=target;
                            return beforeToday && afterTarget;
                        }

                        question.actions = function(question, questionMap, language){
                            var targets = [36,37,38,46];
                            var source_1 = 29;
                            var question_1 = questionMap[source_1]
                            var date1_raw = question_1.value[1][1];
                            var date1 = question_1.value[1][1]!=null ? new Date(question_1.value[1][1]) : null;
                            
                            var source_2 = 30
                            var question_2 = questionMap[source_2]
                            var date2_raw = question_2.value[1][1];
                            var date2 = question_2.value[1][1]!=null ? new Date(question_2.value[1][1]) : null;
                            
                            
                            if(date1 && date2){
                                for(let t=0; t<targets.length; t++){
                                    var target_id = targets[t];
                                    var target = questionMap[target_id];
                                    target.update.subtext({
                                        es: "La terapia mCRPC de primera línea ocurrió entre <span style='color:red;'>"+date1_raw+"</span> y <span style='color:red;'>"+date2_raw+"</span>",
                                        en: "First Line mCRPC therapy occurred between  <span style='color:red;'>"+date1_raw+"</span> and <span style='color:red;'>"+date2_raw+"</span>",
                                        pt: "A terapia de primeira linha para CPRCm ocorreu entre: <span style='color:red;'>"+date1_raw+"</span> e <span style='color:red;'>"+date2_raw+"</span>"
                                    })
                                }
                            }             
                        }
                    }else{
                        console.error('Expected DatePicker',question);
                    }
                break;

                case 30:
                    if(question.config.type=='DatePicker'){
                        question.config.type_modifier.DatePicker.allow_dates = function(val){
                            var today = new Date();
                            var date = new Date(val);

                            var t1 = 29;
                            var target = component.questionMap[t1].value[1][1] ? new Date(component.questionMap[t1].value[1][1]) : null;
                            var beforeToday = date<=today;
                            var afterTarget = date>=target;
                            return beforeToday && afterTarget;
                        }

                        question.actions = component.questionMap[29].actions;
                    }else{
                        console.error('Expected DatePicker',question);
                    }
                break;

                case 36:
                    if(question.config.type=='DatePicker'){
                        question.config.type_modifier.DatePicker.allow_dates = function(val){
                            var today = new Date();
                            var date = new Date(val);

                            var t1 = 29;
                            var t2 = 30;
                            var target_1 = component.questionMap[t1].value[1][1] ? new Date(component.questionMap[t1].value[1][1]) : null;
                            var target_2 = component.questionMap[t2].value[1][1] ? new Date(component.questionMap[t2].value[1][1]) : null;

                            var beforeToday = date<=today;
                            var afterTarget_1 = date>=target_1;
                            var befoerTarget_2 = date<=target_2;
                            return beforeToday && afterTarget_1 && befoerTarget_2;
                        }
                    }else{
                        console.error('Expected DatePicker',question);
                    }
                break;

                case 37:
                    if(question.config.type=='DatePicker'){
                        question.config.type_modifier.DatePicker.allow_dates = function(val){
                            var today = new Date();
                            var date = new Date(val);

                            var t1 = 29;
                            var t2 = 30;
                            var target_1 = component.questionMap[t1].value[1][1] ? new Date(component.questionMap[t1].value[1][1]) : null;
                            var target_2 = component.questionMap[t2].value[1][1] ? new Date(component.questionMap[t2].value[1][1]) : null;

                            var beforeToday = date<=today;
                            var afterTarget_1 = date>=target_1;
                            var befoerTarget_2 = date<=target_2;
                            return beforeToday && afterTarget_1 && befoerTarget_2;
                        }
                    }else{
                        console.error('Expected DatePicker',question);
                    }
                break;

                case 38:
                    if(question.config.type=='DatePicker'){
                        question.config.type_modifier.DatePicker.allow_dates = function(val){
                            var today = new Date();
                            var date = new Date(val);

                            var t1 = 29;
                            var t2 = 30;
                            var target_1 = component.questionMap[t1].value[1][1] ? new Date(component.questionMap[t1].value[1][1]) : null;
                            var target_2 = component.questionMap[t2].value[1][1] ? new Date(component.questionMap[t2].value[1][1]) : null;

                            var beforeToday = date<=today;
                            var afterTarget_1 = date>=target_1;
                            var befoerTarget_2 = date<=target_2;
                            return beforeToday && afterTarget_1 && befoerTarget_2;
                        }
                    }else{
                        console.error('Expected DatePicker',question);
                    }
                break;




                case 46:
                    if(question.config.type=='DatePicker'){
                        question.config.type_modifier.DatePicker.allow_dates = function(val){
                            var today = new Date();
                            var date = new Date(val);

                            var t1 = 30;
                            var target = component.questionMap[t1].value[1][1] ? new Date(component.questionMap[t1].value[1][1]) : null;
                            var beforeToday = date<=today;
                            var afterTarget = date>=target;
                            return beforeToday && afterTarget;
                        }

                        question.actions = function(question, questionMap, language){
                            var targets = [53,54,55,62];
                            var source_1 = 46;
                            var question_1 = questionMap[source_1]
                            var date1_raw = question_1.value[1][1];
                            var date1 = question_1.value[1][1]!=null ? new Date(question_1.value[1][1]) : null;
                            
                            var source_2 = 47
                            var question_2 = questionMap[source_2]
                            var date2_raw = question_2.value[1][1];
                            var date2 = question_2.value[1][1]!=null ? new Date(question_2.value[1][1]) : null;
                            
                            
                            if(date1 && date2){
                                for(let t=0; t<targets.length; t++){
                                    var target_id = targets[t];
                                    var target = questionMap[target_id];
                                    target.update.subtext({
                                        es: "La terapia mCRPC de segunda línea ocurrió entre  <span style='color:red;'>"+date1_raw+"</span> y <span style='color:red;'>"+date2_raw+"</span>",
                                        en: "Second-line mCRPC therapy occurred between  <span style='color:red;'>"+date1_raw+"</span> and <span style='color:red;'>"+date2_raw+"</span>",
                                        pt: "A terapia de segunda-linha de mCRPC ocorreu entre  <span style='color:red;'>"+date1_raw+"</span> e <span style='color:red;'>"+date2_raw+"</span>"
                                    })
                                }
                            }             
                        }

                        // question.actions = function(question, questionMap, language){
                        //     var target_id = 62
                        //     var source_1 = 46;
                        //     var question_1 = questionMap[source_1]
                        //     var date1_raw = question_1.value[1][1];
                        //     var date1 = question_1.value[1][1]!=null ? new Date(question_1.value[1][1]) : null;
                            
                        //     var source_2 = 47
                        //     var question_2 = questionMap[source_2]
                        //     var date2_raw = question_2.value[1][1];
                        //     var date2 = question_2.value[1][1]!=null ? new Date(question_2.value[1][1]) : null;
                            
                            
                        //     if(date1 && date2){
                        //         var target = questionMap[target_id];
                        //         target.update.subtext({
                        //             es: "La terapia mCRPC de segunda línea ocurrió entre  <span style='color:red;'>"+date1_raw+"</span> y <span style='color:red;'>"+date2_raw+"</span>",
                        //             en: "Second-line mCRPC therapy occurred between  <span style='color:red;'>"+date1_raw+"</span> and <span style='color:red;'>"+date2_raw+"</span>"
                        //         })
                        //     }
                                          
                        // }
                    }else{
                        console.error('Expected DatePicker',question);
                    }
                break;

                case 47:
                    if(question.config.type=='DatePicker'){
                        question.config.type_modifier.DatePicker.allow_dates = function(val){
                            var today = new Date();
                            var date = new Date(val);

                            var t1 = 46;
                            var target = component.questionMap[t1].value[1][1] ? new Date(component.questionMap[t1].value[1][1]) : null;
                            var beforeToday = date<=today;
                            var afterTarget = date>=target;
                            return beforeToday && afterTarget;
                        }

                        question.actions = component.questionMap[46].actions;

                        // question.actions = function(question, questionMap, language){
                        //     var target_id = 62
                        //     var source_1 = 46;
                        //     var question_1 = questionMap[source_1]
                        //     var date1_raw = question_1.value[1][1];
                        //     var date1 = question_1.value[1][1]!=null ? new Date(question_1.value[1][1]) : null;
                            
                        //     var source_2 = 47
                        //     var question_2 = questionMap[source_2]
                        //     var date2_raw = question_2.value[1][1];
                        //     var date2 = question_2.value[1][1]!=null ? new Date(question_2.value[1][1]) : null;
                            
                            
                        //     if(date1 && date2){
                        //         var target = questionMap[target_id];
                        //         target.update.subtext({
                        //             es: "La terapia mCRPC de segunda línea ocurrió entre  <span style='color:red;'>"+date1_raw+"</span> y <span style='color:red;'>"+date2_raw+"</span>",
                        //             en: "Second-line mCRPC therapy occurred between  <span style='color:red;'>"+date1_raw+"</span> and <span style='color:red;'>"+date2_raw+"</span>"
                        //         })
                        //     }          
                        // }
                    }else{
                        console.error('Expected DatePicker',question);
                    }
                break;

                case 53:
                    if(question.config.type=='DatePicker'){
                        question.config.type_modifier.DatePicker.allow_dates = function(val){
                            var today = new Date();
                            var date = new Date(val);

                            var t1 = 46;
                            var t2 = 47;
                            var target_1 = component.questionMap[t1].value[1][1] ? new Date(component.questionMap[t1].value[1][1]) : null;
                            var target_2 = component.questionMap[t2].value[1][1] ? new Date(component.questionMap[t2].value[1][1]) : null;

                            var beforeToday = date<=today;
                            var afterTarget_1 = date>=target_1;
                            var befoerTarget_2 = date<=target_2;
                            return beforeToday && afterTarget_1 && befoerTarget_2;
                        }
                    }else{
                        console.error('Expected DatePicker',question);
                    }
                break;

                case 54:
                    if(question.config.type=='DatePicker'){
                        question.config.type_modifier.DatePicker.allow_dates = function(val){
                            var today = new Date();
                            var date = new Date(val);

                            var t1 = 46;
                            var t2 = 47;
                            var target_1 = component.questionMap[t1].value[1][1] ? new Date(component.questionMap[t1].value[1][1]) : null;
                            var target_2 = component.questionMap[t2].value[1][1] ? new Date(component.questionMap[t2].value[1][1]) : null;

                            var beforeToday = date<=today;
                            var afterTarget_1 = date>=target_1;
                            var befoerTarget_2 = date<=target_2;
                            return beforeToday && afterTarget_1 && befoerTarget_2;
                        }
                    }else{
                        console.error('Expected DatePicker',question);
                    }
                break;

                case 55:
                    if(question.config.type=='DatePicker'){
                        question.config.type_modifier.DatePicker.allow_dates = function(val){
                            var today = new Date();
                            var date = new Date(val);

                            var t1 = 46;
                            var t2 = 47;
                            var target_1 = component.questionMap[t1].value[1][1] ? new Date(component.questionMap[t1].value[1][1]) : null;
                            var target_2 = component.questionMap[t2].value[1][1] ? new Date(component.questionMap[t2].value[1][1]) : null;

                            var beforeToday = date<=today;
                            var afterTarget_1 = date>=target_1;
                            var befoerTarget_2 = date<=target_2;
                            return beforeToday && afterTarget_1 && befoerTarget_2;
                        }
                    }else{
                        console.error('Expected DatePicker',question);
                    }
                break;




                case 62:
                    if(question.config.type=='DatePicker'){
                        question.config.type_modifier.DatePicker.allow_dates = function(val){
                            var today = new Date();
                            var date = new Date(val);

                            var t1 = 47;
                            var target = component.questionMap[t1].value[1][1] ? new Date(component.questionMap[t1].value[1][1]) : null;
                            var beforeToday = date<=today;
                            var afterTarget = date>=target;
                            return beforeToday && afterTarget;
                        }

                        question.actions = function(question, questionMap, language){
                            var targets = [70,71,72];
                            var source_1 = 62;
                            var question_1 = questionMap[source_1]
                            var date1_raw = question_1.value[1][1];
                            var date1 = question_1.value[1][1]!=null ? new Date(question_1.value[1][1]) : null;
                            
                            
                            if(date1){
                                for(let t=0; t<targets.length; t++){
                                    var target_id = targets[t];
                                    var target = questionMap[target_id];
                                    target.update.subtext({
                                        es: "La terapia mCRPC de terceira línea ocurrió entre <span style='color:red;'>"+date1_raw+"</span>",
                                        en: "Third-line mCRPC therapy was initiated <span style='color:red;'>"+date1_raw+"</span>",
                                        pt: "A terapia de terceira-linha de mCRPC foi iniciada <span style='color:red;'>"+date1_raw+"</span>"
                                    })
                                }
                            }             
                        }
                    }else{
                        console.error('Expected DatePicker',question);
                    }
                break;

                case 64:
                    if(question.config.type=='DatePicker'){
                        question.config.type_modifier.DatePicker.allow_dates = function(val){
                            var today = new Date();
                            var date = new Date(val);

                            var t1 = 62;
                            var target = component.questionMap[t1].value[1][1] ? new Date(component.questionMap[t1].value[1][1]) : null;
                            var beforeToday = date<=today;
                            var afterTarget = date>=target;
                            return beforeToday && afterTarget;
                        }
                    }else{
                        console.error('Expected DatePicker',question);
                    }
                break;






                case 70:
                    if(question.config.type=='DatePicker'){
                        question.config.type_modifier.DatePicker.allow_dates = function(val){
                            var today = new Date();
                            var date = new Date(val);

                            var t1 = 62;
                            var t2 = 64;
                            var target_1 = component.questionMap[t1].value[1][1] ? new Date(component.questionMap[t1].value[1][1]) : null;
                            var target_2 = component.questionMap[t2].value[1][1] ? new Date(component.questionMap[t2].value[1][1]) : null;

                            var beforeToday = date<=today;
                            var afterTarget_1 = date>=target_1;
                            var befoerTarget_2 = date<=target_2;
                            return beforeToday && afterTarget_1 && befoerTarget_2;
                        }
                    }else{
                        console.error('Expected DatePicker',question);
                    }
                break;

                case 71:
                    if(question.config.type=='DatePicker'){
                        question.config.type_modifier.DatePicker.allow_dates = function(val){
                            var today = new Date();
                            var date = new Date(val);

                            var t1 = 62;
                            var t2 = 64;
                            var target_1 = component.questionMap[t1].value[1][1] ? new Date(component.questionMap[t1].value[1][1]) : null;
                            var target_2 = component.questionMap[t2].value[1][1] ? new Date(component.questionMap[t2].value[1][1]) : null;

                            var beforeToday = date<=today;
                            var afterTarget_1 = date>=target_1;
                            var befoerTarget_2 = date<=target_2;
                            return beforeToday && afterTarget_1 && befoerTarget_2;
                        }
                    }else{
                        console.error('Expected DatePicker',question);
                    }
                break;

                case 72:
                    if(question.config.type=='DatePicker'){
                        question.config.type_modifier.DatePicker.allow_dates = function(val){
                            var today = new Date();
                            var date = new Date(val);

                            var t1 = 62;
                            var t2 = 64;
                            var target_1 = component.questionMap[t1].value[1][1] ? new Date(component.questionMap[t1].value[1][1]) : null;
                            var target_2 = component.questionMap[t2].value[1][1] ? new Date(component.questionMap[t2].value[1][1]) : null;

                            var beforeToday = date<=today;
                            var afterTarget_1 = date>=target_1;
                            var befoerTarget_2 = date<=target_2;
                            return beforeToday && afterTarget_1 && befoerTarget_2;
                        }
                    }else{
                        console.error('Expected DatePicker',question);
                    }
                break;                
            }
        }
    },
    afterSubmit: function(component, server_reply){
        return new Promise((resolve, reject)=>{
            var questionMap = component.questionMap;

            // var age = questionMap[5];
            
            var questions = {
                5: questionMap[5],
                14: questionMap[14],
                17: questionMap[17],
                27: questionMap[27],
                28: questionMap[28],
                31: questionMap[31],
                43: questionMap[43],
                45: questionMap[45],
                48: questionMap[48],
                60: questionMap[60],
                61: questionMap[61],
                65: questionMap[65]
            }

            var user_id = component.$store.getters.user.id;
            var user_email = component.$store.getters.user.email;
            var submission_id = server_reply ? server_reply.submission_id : 'N/A';
            var language = server_reply ? server_reply.language : 'en';

            var rules = {
                rule_27: {
                    q_14: component.$root.in_array(questions[14].value[1],[2,3,4,5]),
                    q_27: component.$root.in_array(questions[27].value[1],[5])
                },
                rule_28: {
                    q_28: component.$root.in_array(questions[28].value[1],[3])
                },
                rule_31: {
                    q_27: component.$root.in_array(questions[27].value[1],[5]),
                    q_31: component.$root.in_array(questions[31].value[1],[1,2,3,5])
                },
                rule_43: {
                    q_14: component.$root.in_array(questions[14].value[1],[3,4,5]),
                    q_43: component.$root.in_array(questions[43].value[1],[5])
                },
                rule_45: {
                    q_45: component.$root.in_array(questions[45].value[1],[3])
                },
                rule_48: {
                    q_43: component.$root.in_array(questions[43].value[1],[5]),
                    q_48: component.$root.in_array(questions[48].value[1],[1,2,3,5])
                },
                rule_60: {
                    q_14: component.$root.in_array(questions[14].value[1],[4,5]),
                    q_60: component.$root.in_array(questions[60].value[1],[5])
                },
                rule_61: {
                    q_61: component.$root.in_array(questions[61].value[1],[3])
                },
                rule_65: {
                    q_60: component.$root.in_array(questions[60].value[1],[5]),
                    q_65: component.$root.in_array(questions[65].value[1],[1,2,3,5])
                }
            }


            function return_label(id, others, inputs){
                if(typeof id=='object' && id!=null){
                    return id[1];
                }
                for(let i=0; i<inputs.length; i++){
                    var item = inputs[i];
                    if(item.id == id){
                        return item.label.en + (others[id] ? ': '+others[id] : '');
                    }
                }
                return 'N/A'
            }
            
            var action = 'survey';
            var call = 'report_adverse_event';
            var data = {
                subject: component.program.name.en+' AE Triggered',
                to: 'jtoth@ctccomm.com',
                message: "<fieldset><legend>IMAP AE Triggered</legend>Program: IMAP "+component.program.name.en+" ["+language+"]<br>User ID: "+user_id+"<br>User: "+user_email+"<br>Submission ID: "+submission_id+"<p>Adverse event(s) triggered during the submission of the survey.  The details are as follows:<ul>"
            }    

            var triggered = false;
            for(let rule_name in rules){
                var rule = rules[rule_name];
                
                if(component.$root.allTrue(rule)){
                    triggered = true;
                    console.log('AE Rule Triggered: '+rule_name,rule);
                }
            }

            var content = {}
            for(let qid in questions){
                var question = questions[qid];
                
                if(!content[qid]){
                    content[qid] = {question:question.config.body.en,selection: return_label(question.value[1], question.other[1], question.config.groups[0].inputs)}
                }
            }            


            for(let qid in content){
                var record = content[qid];
                data.message+="<li><b>"+record.question+"</b> <br>"+record.selection+"</li>"
            }

            data.message+="</ul></fieldset>";


            if(triggered){
                component.$sendRequest({
                    action: action,
                    call: call,
                    data: data
                }).then(function(response){
                    resolve();
                },function(response){                 
                    reject(response);
                })                
            }else{
                resolve();
            }

            console.log('AFTER SUBMIT',{
                rules: rules,
                data: data,
                content: content
            })

            
        },function(response){
            reject(response);
        })
    }
}